import React from 'react'
import './styles.css'
import { useLocalState } from '../../shared/UseLocalState'
import { authState } from '../../state/Auth.state'
import { Person } from '../../api'

interface NavigationProps {
  loggedIn: boolean
  linkClicked: () => void
}

export const Navigation = ({ loggedIn, linkClicked }: NavigationProps) => {
  const user = useLocalState<Person | null>(authState.user$, authState.user$.value)
  const database = user?.database

  return (
    <nav style={{ zIndex: 1000 }}>
      <div className='nav-container'>
        {loggedIn && (
          <>
            <a href='#/home' className='nav-link' onClick={linkClicked}>
              Startseite
            </a>
            <a href='#/registration' className='nav-link' onClick={linkClicked}>
              Online-Nennung
            </a>
            <a href='#/address-change' className='nav-link' onClick={linkClicked}>
              Adressänderung
            </a>
            <a href='#/horses' className='nav-link' onClick={linkClicked}>
              Pferd registrieren
            </a>
            <a href='#/person-register' className='nav-link' onClick={linkClicked}>
              Person registrieren
            </a>
          </>
        )}
              {/**/} <a href='#/history' className='nav-link' onClick={linkClicked}>
          IGV Datenbank
        </a> 
        <a href='mailto:service@pfae.org' className='nav-link'>
          Kontakt
        </a>
        <a href='https://www.pfae.org/online-nennung' target='_blank' className='nav-link'>
          Hilfe
        </a>
      </div>
      <div className='nav-footer' style={database && database !== 'hmdat' ? { backgroundColor: 'orange', color: '#000' } : undefined}>
              &copy; 2026 JK &amp; JT.<br />
        {database && <span style={{ marginLeft: '1rem', opacity: 0.6, fontSize: '0.8em' }}>{database}</span>}
      </div>
    </nav>
  )
}
